import "./Industries.module.css";
import Header from "@/reusable_sections/Header";
import Expertise from "./sections/Expertise";
import Success from "./sections/Success";
import SuccessCopy from "./sections/SuccessCopy";
import Applications from "./sections/Applications";
import OperationsMapVisualization from "./sections/OperationsMapVisualization";
import Footer from "@/reusable_sections/Footer";
export default function IndustriesPage() {
  return <div>
      <Header />
      <Expertise />
      <Success />
      <SuccessCopy />
      <Applications />
      <OperationsMapVisualization />
      <Footer />
    </div>;
}